// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"1b546884","208":"77347a4b","267":"4e3a06b9"}[chunkId] + ".chunk.css";
};